// ============================================================================
// FIREBASE CONFIGURATION - FREE STATE GOLF UNION
// ============================================================================

import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// ============================================================================
// FIREBASE CONFIG
// ============================================================================
const firebaseConfig = {
  apiKey: "AIzaSyD02nYAi0CFDS0T_TEX0Tku59UxvQG4m0E",
  authDomain: "fsgu-site.firebaseapp.com",
  projectId: "fsgu-site",
  storageBucket: "fsgu-site.firebasestorage.app",
  messagingSenderId: "263823427990",
  appId: "1:263823427990:web:33a8819ba5d975c38b35b7",
  measurementId: "G-FK90T3X2BT"
};

// ============================================================================
// INITIALIZE FIREBASE
// ============================================================================
const app = initializeApp(firebaseConfig);

// ============================================================================
// INITIALIZE SERVICES
// ============================================================================
// Analytics - only initialize in browser environment
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

// Authentication
export const auth = getAuth(app);

// Firestore Database
export const db = getFirestore(app);

// Cloud Storage
export const storage = getStorage(app);

// ============================================================================
// EXPORTS
// ============================================================================
export { app, analytics };
export default app;

// ============================================================================
// HELPER FUNCTIONS
// ============================================================================

/**
 * Log analytics event
 * @param {string} eventName - Name of the event
 * @param {object} eventParams - Event parameters
 */
export const logAnalyticsEvent = (eventName, eventParams = {}) => {
  if (analytics) {
    try {
      logEvent(analytics, eventName, {
        ...eventParams,
        timestamp: new Date().toISOString(),
        source: 'fsgu_website'
      });
    } catch (error) {
      console.warn('Analytics event logging failed:', error);
    }
  }
};

/**
 * Check if Firebase is initialized and ready
 */
export const isFirebaseReady = () => {
  return !!app;
};

/**
 * Log page view event
 * @param {string} pageName - Name of the page
 * @param {string} path - Page path
 */
export const logPageView = (pageName, path) => {
  logAnalyticsEvent('page_view', {
    page_name: pageName,
    page_path: path
  });
};

/**
 * Log user interaction event
 * @param {string} action - Action type (click, download, etc.)
 * @param {string} category - Event category
 * @param {string} label - Event label
 */
export const logUserInteraction = (action, category, label = '') => {
  logAnalyticsEvent('user_interaction', {
    action,
    category,
    label
  });
};

/**
 * Log tournament event interaction
 * @param {string} action - Action type (view, register, etc.)
 * @param {string} tournamentName - Tournament name
 */
export const logTournamentEvent = (action, tournamentName) => {
  logAnalyticsEvent('tournament_interaction', {
    action,
    tournament: tournamentName
  });
};